import PropTypes from 'prop-types';
import styled from 'styled-components';
var DrawerActions = styled.div.withConfig({
  displayName: "DrawerActions",
  componentId: "sc-79lb60-0"
})(["padding:var(--size-spacing-05);border-top:1px solid var(--color-gray-20);text-align:right;"]);
DrawerActions.defaultProps = {
  children: undefined
};
DrawerActions.propTypes = {
  /**
   * Should be a Button like for a single action or a ButtonGroup component
   */
  children: PropTypes.node
};
export default DrawerActions;